import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'order-summaries',
    templateUrl: './order-summaries.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderSummariesComponent {
  @Input() public title: string;

  @Output() public toggleSave: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  public isOpen = false;
  cmpRef: ComponentRef<any>;
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();

  public component: any;
  public items: any;

  public updateOrder(item: any, index: number, offset: number) {
    this.items = _.orderBy(this.items, ['order']);
    let length = this.items.length - 1;

    if (index === 0 && offset < 0) {
      this.items[length].order = 1;
      this.items[index].order = length + 1;
    } else if (index === length && offset > 0) {
      this.items[index].order = 1;
      this.items[0].order = length + 1;
    } else {
      item.order = item.order + offset;
      let nearItem = this.items[index + offset];
      nearItem.order = nearItem.order - offset;
    }

    this.items = _.orderBy(this.items, ['order']);
    this.cdf.detectChanges();
  }

  public save() {
    this.dispose();
    this.toggleSave.emit(this.items);
  }

  public cancel() {
    this.dispose();
    this.toggleCancel.emit();
  }

  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef
  ) {}

  open(items: any) {
    items = _.uniqBy(items, 'id');
    this.items = _.orderBy(items, ['order']);
    //fix orders
    _.forEach(this.items, (v: any, k: number) => {
      v.order = k + 1;
    });
    this.isOpen = true;
    this.cdf.detectChanges();
  }

  dispose() {
    this.isOpen = false;
    if (this.component != undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }

  close() {
    this.dispose();
  }
}
